import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../sunpharma(1)/css/case_study.css';
import HomeBtn from "../components/HomeBtn";

import { GrChapterPrevious } from "react-icons/gr";
import { GrChapterNext } from "react-icons/gr";

import Footer from '../components/footer';
import Com_Logo from '../components/company_icon';

const CaseCh1 = () => {
  const navigate = useNavigate();

  const dataList = [
    {
      header: "Patient : 68-year-old male",
      title: "Chief Complaint :",
      items: ["Sudden weakness on the left side of the body and slurred speech for the past 3 hours."],
    },
    {
      header: "Patient : 68-year-old male",
      title: "History of Present Illness :",
      items: ["The patient was watching TV when he suddenly developed weakness in his left arm and leg.", "His family noticed slurred speech and facial drooping on the left side.", "No loss of consciousness, seizures, or headache reported.","He has a history of hypertension, type 2 diabetes, and smoking."],
    },
    {
      header: "Patient : 68-year-old male",
      title: "Examination Findings :",
      items: ["Blood Pressure :  170/95 mmHg "],
    },
        {
      header: "Patient : 68-year-old male",
      title: "Neurological Exam :",
      items: ["Left-sided facial droop (lower face).","Left arm and leg weakness (power 2/5).","Left-sided hyperreflexia.","Positive Babinski sign on the left."," No sensory deficits. ","Speech: Dysarthric but comprehension intact."],
    },
    {
      header: "Patient : 68-year-old male",
      title: "Diagnostic Workup :",
      items: ["Non-contrast CT head : No hemorrhage, early signs of right MCA territory ischemia.","MRI (DWI) : Acute infarct in the right middle cerebral artery (MCA) territory.", "Carotid Doppler:** Right internal carotid artery (ICA) stenosis (70%).","Diagnosis : Acute Ischemic Stroke (Right MCA Infarction)."],
    },
    {
      header: "Patient : 68-year-old male",
      title: "Management :",
      items: ["IV **Alteplase (tPA)** administered within the 4.5-hour window.","Antiplatelet therapy (**Aspirin 325 mg**) started after tPA.","Blood pressure control (**Labetalol**).","Statin (**Atorvastatin**) and diabetes management.","Referral to stroke rehabilitation."],
    },
        {
      header: "Patient : 68-year-old male",
      title: "Outcome :",
      items: ["Gradual improvement in left-sided weakness over weeks.","Persistent mild dysarthria but able to walk with a cane."],
    },

  ];

  const [activeIndex, setActiveIndex] = useState(0);
  const current = dataList[activeIndex];

  const handlePrev = () => {
    navigate('../case_event');
  };

  const handleNext = () => {
    navigate('../mcq');
  };

// handle next and prev button throw change content

const Prev = () => {
  if (activeIndex > 0) {
    setActiveIndex(prev => prev - 1);
  }
};

const Next = () => {
  if (activeIndex < dataList.length - 1) {
    setActiveIndex(prev => prev + 1);
  }
};



  return (
    <>
      <Com_Logo />
      <div className="case-container">
        <div className="case-card">
          <div className="case-header">
            E - Case Study : Ischemic Stroke with Left Hemipare sis
          </div>
          <div className="case-body">

        {/* content change button throw */}
        <div className="case-footer">
          <button
            id="ConChangeBtn"
            className="btn btn-secondary"
            onClick={Prev}
            disabled={activeIndex === 0}
          >
            <GrChapterPrevious size={20} id="ConChangeicon"/>
          </button>
        <p className="text-center mt-2">
          {activeIndex + 1} / {dataList.length}
        </p>
          <button
            id="ConChangeBtn"
            className="btn btn-primary"
            onClick={Next}
            disabled={activeIndex === dataList.length - 1}
          >
            <GrChapterNext size={20} id="ConChangeicon"/>
          </button>
        </div>


            {/* chiled card */}

            <div className="child-card">
              <div className="child-header">
                {current.header}
              </div>
              <div className="child-body">
                <h5 className="child-title">{current.title}</h5>
                <ul className="custom-bullet">
                  {current.items.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="case-footer">
            <button className="btn btn-secondary" onClick={handlePrev}>Prev</button>
            <HomeBtn/>
            <button className="btn btn-primaryy" onClick={handleNext}>Next</button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CaseCh1;
